module.exports = new __parcel__URL__("error-white.e2723ea8.svg").toString();